import { ILog, ILogListRequestPayload, IUpsertLogPayload, IUpsertLogsPayload } from 'bom/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getLogs = async (
  requestPayload: ILogListRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ILog>> => {
  const { data } = await partfinitiClient.get(
    `/bom/log-list/logs?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ILog>(data.data, data.recordsFiltered);
};

export const upsertLog = async (data: IUpsertLogPayload) =>
  partfinitiClient.postForm('/bom/log-edit/save', data, {
    includeNullValues: true,
  });

export const upsertLogs = async (data: IUpsertLogsPayload) =>
  partfinitiClient.postForm('/bom/log-edit/save-bulk', data, {
    includeNullValues: true,
  });

export const removeLogs = async (data: { ids: number[] }) =>
  partfinitiClient.postForm('/bom/log-edit/remove', data);
